import PropTypes from 'prop-types';

// Placeholder for the Jivan character (SYN-16: "Jivan character icon/face", an Ask
// Jeeves-style Easter egg). Swap the SVG for the real artwork when it exists; every
// place that shows Jivan renders this component.
const JivanFace = ({ size }) => (
    <svg width={size} height={size} viewBox="0 0 64 64" role="img" aria-label="Jivan" data-testid="jivan-face">
        <circle cx="32" cy="32" r="30" fill="#EDE7F6" stroke="#5E35B1" strokeWidth="2" />
        {/* hair */}
        <path d="M14 27c1-12 10-18 18-18s17 6 18 18c-5-7-11-9-18-9s-13 2-18 9z" fill="#4527A0" />
        {/* eyes and the monocle */}
        <circle cx="24" cy="32" r="2.5" fill="#311B92" />
        <circle cx="40" cy="32" r="2.5" fill="#311B92" />
        <circle cx="40" cy="32" r="6.5" fill="none" stroke="#5E35B1" strokeWidth="1.5" />
        <path d="M46 35l3 12" stroke="#5E35B1" strokeWidth="1.2" fill="none" />
        {/* smile */}
        <path d="M24 42c4 5 12 5 16 0" stroke="#311B92" strokeWidth="2" fill="none" strokeLinecap="round" />
        {/* bow tie */}
        <path d="M32 55l-7-4v8zM32 55l7-4v8z" fill="#5E35B1" />
    </svg>
);

JivanFace.propTypes = {
    size: PropTypes.number
};

JivanFace.defaultProps = {
    size: 40
};

export default JivanFace;
